module.exports = __webpack_public_path__ + "static/george-5bbeb249ff907cfd75edca884d53abf9.jpg";